// FILE: src/pages/info/GlossaryPage.jsx
// The course glossary as a page (MTO 18.1). The same list opens from the
// top bar on every signed-in page.
import React from "react";
import InfoPage from "./InfoPage";
import Glossary from "../../components/help/Glossary";

export default function GlossaryPage({ variant = "public" }) {
  return (
    <InfoPage
      variant={variant}
      title="Glossary"
      description="What the words and abbreviations used in the course mean."
    >
      <Glossary headingLevel={2} />
    </InfoPage>
  );
}
